const routes = [
    // 처음 페이지 접속시 로딩되는 페이지
    { path: "/", redirect: "/daily-briefing" },
    // 로그인 페이지
    {
      path: "/login",
      name: "LoginView",
      component: () => import("@/components/login/index.vue"),
      props: true,
    },
    {
        path: "/daily-briefing",
        name: "DailyBriefing",
        component: ()=> import("@/components/daily-briefing/index.vue"),
        props: true,
    },
    {
        path: "/admin",
        name: "AdminView",
        component: ()=> import("@/components/admin/index.vue"),
        props: true,
    },
    {
        path: "/error",
        name: "ErrorView",
        component: ()=> import("@/components/error/index.vue"),
        props: true,
    },
    { path: "/:pathMatch(.*)*", redirect: "/daily-briefing" },
];

export default routes;